export default "__VITE_ASSET__CtU1kBqw__"